export default function($rootScope, $timeout, $compile, $window) {
  "ngInject";
  return function(scope, element, attrs) {
    scope.$watch(
      (scope) => {
        return scope.$eval(attrs.compile);
      },
      (value) => {
        element.html(value);
        $compile(element.contents())(scope);
      }
    )
  };
}



// WEBPACK FOOTER //
// ./client/app/common/directives/compile.directive.js